import { GetMemberResponse } from "../api/types/get-member.types";
import { Summary } from "../api/types/get-summaries.types";
import {
  UsersSyncResponse,
  CurrentSubscription,
} from "../api/types/users-sync.types";

export const selectIsDemoUser = (subscription?: CurrentSubscription) => {
  const isDemoUser =
    subscription?.is_active === false &&
    subscription?.is_trial === false &&
    subscription?.is_trial_active === false;
  return isDemoUser;
};

export const selectIsTrialUser = (subscription?: CurrentSubscription) => {
  const isTrialUser =
    subscription?.is_trial === true && subscription?.is_active === false;
  return isTrialUser;
};

export const selectIsUnpaidUser = (subscription?: CurrentSubscription) => {
  return selectIsTrialUser(subscription) || selectIsDemoUser(subscription);
};

export const selectUserPaidStatus = (user?: UsersSyncResponse) => {
  const isDemoUser = selectIsDemoUser(user?.current_subscription);
  const isTrialUser = selectIsTrialUser(user?.current_subscription);
  return {
    isDemoUser,
    isTrialUser,
    isUnpaidUser: isDemoUser || isTrialUser,
    user,
  };
};

export const selectIsFreeTier = (summaries: Summary[]) => {
  const activePlans = summaries.filter((s) => {
    const isActive = s.is_active;
    const isNotTrial = !s.is_trial;
    return isActive && isNotTrial;
  });

  if (activePlans?.length === 1) {
    return {
      summaries,
      isFreeTier: activePlans?.[0]?.subscription?.plan?.slug === "free-tier",
    };
  }

  return {
    summaries,
    isFreeTier: false,
  };
};

export const selectIsBizPhonePlan = (summaries: Summary[]) => {
  if (summaries?.length) {
    const isBizPhonePlan = summaries.every((s) => {
      return s?.subscription?.plan?.id === 18;
    });

    return { isBizPhonePlan };
  }
  return { isBizPhonePlan: false };
};

export const selectIsAllInOneLitePlan = (summaries: Summary[]) => {
  if (summaries?.length) {
    const isAllInOneLitePlan = summaries.every((s) => {
      return s?.subscription?.plan?.id === 19;
    });

    return { isAllInOneLitePlan };
  }

  return { isAllInOneLitePlan: false };
};

export const selectIsAllInOneProPlan = (summaries: Summary[]) => {
  if (summaries?.length) {
    const isAllInOneProPlan = summaries.every((s) => {
      return s?.subscription?.plan?.id === 20;
    });

    return { isAllInOneProPlan };
  }

  return { isAllInOneProPlan: false };
};

export const selectSummariesWithFlags = (summaries: Summary[]) => {
  const { isFreeTier } = selectIsFreeTier(summaries || []);
  const { isBizPhonePlan } = selectIsBizPhonePlan(summaries || []);
  const { isAllInOneLitePlan } = selectIsAllInOneLitePlan(summaries || []);
  const { isAllInOneProPlan } = selectIsAllInOneProPlan(summaries || []);

  return {
    isFreeTier,
    isBizPhonePlan,
    isAllInOneLitePlan,
    isAllInOneProPlan,
    summaries,
  };
};

export const selectIsNumberMaskingEnabled = (
  data?: GetMemberResponse,
  isFetching?: boolean,
  isLoading?: boolean
) => {
  return {
    data,
    isNumberMaskingEnabled: data?.role_permissions?.some(
      (p) => p?.permissions?.includes("number-masking") || false
    ),
    isFetching: isFetching || false,
    isLoading: isLoading || false,
  };
};
